import React, { useEffect, useState, useRef, Children } from 'react';
import './index.scss';

import { FeatureLabels, FOOTER_DATA } from './constant';
import FeatureCards from './components/FeatureCards';
import ArrowRight from './icon/arrowright.svg';
import { LOCAL_COMPANY } from '@/util/constants';

const dataList = [
  { value: '250+', label: '覆盖城市' },
  { value: '600+', label: '合作桩企' },
  { value: '50000+', label: '在线充电站' },
  { value: '2838w+', label: '累计服务车主' },
];

const AUTO_PLAY_INTERVAL = 8000; // 8秒自动切换

interface HomePageProps {
  user?: {
    loginError?: boolean;
    companyRoles?: { roleId: string }[];
    [key: string]: any;
  };
}

const HomePage: React.FC<HomePageProps> = ({ user }) => {
  const VIEWER_ID = '-1'
  const [activeIndex, setActiveIndex] = useState(0);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  let isLoginedIn = false;
  if (!!user) {
    // 判断是否有桩企
    const { companyRoles } = user;
    if (companyRoles.length === 0 || (companyRoles.length === 1 && companyRoles[0].roleId === VIEWER_ID)) {
      // 说明下面未入住桩企或者下面只有一个桩企还没有入住成功
      isLoginedIn = false;
    } else {
      isLoginedIn = true;
    }
  } else {
    isLoginedIn = false;
  }

  // 预加载图片
  function preloadImages(imgList: string[]) {
    imgList.forEach(src => {
      const img = new window.Image();
      img.src = src;
    });
  }

  const companyId = localStorage.getItem(LOCAL_COMPANY);

  useEffect(() => {
    // 预请求FeatureCards 下的所有图片
    const featureImages = FeatureLabels.flatMap(item => item.children.map(child => child.href));
    preloadImages(featureImages);

    Omega?.trackEvent("charge_cpcp_homepg_sw", "桩企平台首页_曝光", {
      host: location.hostname,
      pub_comanyid: companyId,
      pub_jieru_uid: user?.uid
    });
  }, [companyId, user?.uid]);

  // 自动轮播
  useEffect(() => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setActiveIndex(idx => (idx + 1) % FeatureLabels.length);
    }, AUTO_PLAY_INTERVAL);
    return () => {
      timerRef.current && clearTimeout(timerRef.current);
    };
  }, [activeIndex]);

  // 用户点击时，重置轮播计时
  const handleDotClick = (idx: number) => {
    setActiveIndex(idx);
    timerRef.current && clearTimeout(timerRef.current);
  };

  const handleMouseEnter = () => {
    timerRef.current && clearTimeout(timerRef.current);
  };

  const handleMouseLeave = () => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setActiveIndex(idx => (idx + 1) % FeatureLabels.length);
    }, AUTO_PLAY_INTERVAL);
  };

  useEffect(() => {
    const main = document.querySelector('.main');
    if (main && !main.classList.contains('appear')) {
      setTimeout(() => main.classList.add('appear'), 50);
    }
  }, []);

  return (
    <div>
      {/* 主视觉区 */}
      <div className="main">
        <video
          className="bg"
          poster="https://view.didistatic.com/static/dcms/epower-open-intro.jpg?v=1.1"
          src="https://view.didistatic.com/static/dcms/epower-open-intro.mp4"
          muted
          loop
          autoPlay
          style={{ width: '100%', height: '100%', objectFit: 'fill' }}
        />
        <h2>开放生态 共赢未来</h2>
        <h3>携手滴滴充电·开启智能时代</h3>
        <a className="link" id="attach-link-up">
          { isLoginedIn ? '立即使用' : '立即接入' }</a>
        <ul className="data">
          {dataList.map(item => (
            <li key={item.label}>
              <strong>{item.value}</strong>
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
        <span className="more">
          继续了解
          <i className="arrow"></i>
        </span>
      </div>

      {/* 五大核心能力 */}
      <div className="feature-title">
        <div className="fixed-width">
          <div className="title">
            五大核心能力，让桩企产品更好卖、售后更高效
          </div>
          <div className="feature-content">
            {FeatureLabels.map((item, idx) => (
              <div
                className={`content-dot${activeIndex === idx ? ' active' : ''}`}
                data-index={idx + 1}
                key={item.title}
                onClick={() => handleDotClick(idx)}
              >
                <div className={`icon icon-${idx + 1}${activeIndex === idx ? ' active' : ''}`} />
                <span>{item.title}</span>
                {activeIndex === idx && <div className="dot-bar" />}
              </div>
            ))}
          </div>
        </div>
          {/* 大图展示区 */}
          <div 
            className="feature-image-wrapper" 
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ textAlign: 'center', width: '100%' }}
          >
            <FeatureCards feature={FeatureLabels[activeIndex]} />
          </div>
      </div>


      {/* 多种协议 */}
      <div className="feature-title">
        <div className="title">
          多种协议，适用于不同桩企接入需求
        </div>
        <div className="xieyi-content">
          <div className="xieyi-dot" data-index="1"></div>
          <div className="xieyi-dot" data-index="2"></div>
        </div>
      </div>

      {/* 自主接入流程 */}
      <div className="feature-title zizhu-title" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="title">
          自主接入流程
        </div>
        <div className="feature-content">
          <div className="flow">
          </div>
        </div>
        <div className="feature-btn">
          <a className="link" id="attach-link-down">
            { isLoginedIn ? '立即使用' : '立即接入' }
            <ArrowRight />
          </a>
        </div>
      </div>

      {/* 底部 */}
      <div className="footer">
        <div className="footer-content">
          <div className="contact">
            {FOOTER_DATA.map(section => (
              <div className="contact-item" key={section.title}>
                <div className="contact-item-title">{section.title}</div>
                {section.items.map(item => (
                  <div className='contact-item-link' key={item.name}>
                    {item.link ? <a href={item.link} target="_blank" rel="noopener noreferrer">{item.name}</a> : item.name}
                  </div>
                ))}
              </div>
            ))}
          </div>
          <ul className="follow">
            <li>
              <img src="https://view.didistatic.com/static/dcms/144p2r1z3brme6pzd5e_216x216.png" alt="公众号" />
              公众号
            </li>
          </ul>
        </div>
        <div className="divider"></div>
        <div className="copyright">
          <p>
            <a target="_blank" href="https://www.didiglobal.com/company-info">&copy; 2012-2023 北京小桔科技有限公司 增值电信业务经营许可证：京B2-20192416 B1.B2-20160181 </a>
            <a target="_blank" href="https://img-ys011.didistatic.com/static/didiglobal/do1_GiadxurmXBXpJUJKzUBQ">京ICP证150329号 </a>
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002002025">
              <img style={{ position: 'relative', top: 3 }} src="https://website.didiglobal.com/dist/img/beian.d0289dc0.png" className="police-img" alt="" />
              京公网安备 11000002002025号
            </a>
            <span>违法和不良信息/涉未成年有害信息/算法安全专项举报电话：01083456200 举报邮箱：xinxichuli@didiglobal.com</span>
          </p>
          <p>
            <span>法律条款与平台规则</span>
            <span>网上有害信息举报专区</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default HomePage;